// Mobile Menu Toggle
document.addEventListener('DOMContentLoaded', function() {
    const hamburger = document.querySelector('.hamburger');
    const navMenu = document.querySelector('.nav-menu');
    const navLinks = document.querySelectorAll('.nav-menu a');

    // Toggle mobile menu
    hamburger.addEventListener('click', function() {
        const isExpanded = this.getAttribute('aria-expanded') === 'true';
        navMenu.classList.toggle('active');
        
        // Update ARIA attribute
        this.setAttribute('aria-expanded', !isExpanded);
        
        // Animate hamburger icon
        this.classList.toggle('active');
    });
    
    // Support keyboard for hamburger menu
    hamburger.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            this.click();
        }
    });

    // Close mobile menu when clicking on a link
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            navMenu.classList.remove('active');
            hamburger.classList.remove('active');
            hamburger.setAttribute('aria-expanded', 'false');
        });
    });

    // Smooth scroll for anchor links
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                const offsetTop = target.offsetTop - 70;
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            }
        });
    });

    // Contact Form Handling
    const contactForm = document.getElementById('contactForm');
    const formMessage = document.getElementById('formMessage');
    const nameInput = document.getElementById('name');
    const emailInput = document.getElementById('email');
    const phoneInput = document.getElementById('phone');
    const subjectInput = document.getElementById('subject');
    const messageInput = document.getElementById('message');

    // Real-time validation
    nameInput.addEventListener('blur', function() {
        validateName();
    });

    emailInput.addEventListener('blur', function() {
        validateEmail();
    });

    phoneInput.addEventListener('blur', function() {
        if (this.value) validatePhone();
    });

    subjectInput.addEventListener('blur', function() {
        validateSubject();
    });

    messageInput.addEventListener('blur', function() {
        validateMessage();
    });

    // Clear error on input
    [nameInput, emailInput, phoneInput, subjectInput, messageInput].forEach(input => {
        input.addEventListener('input', function() {
            clearFieldError(this);
        });
    });

    function validateName() {
        const name = nameInput.value.trim();
        if (!name) {
            setFieldError(nameInput, 'Le nom est requis');
            return false;
        }
        if (name.length < 2) {
            setFieldError(nameInput, 'Le nom doit contenir au moins 2 caractères');
            return false;
        }
        clearFieldError(nameInput);
        return true;
    }

    function validateEmail() {
        const email = emailInput.value.trim();
        if (!email) {
            setFieldError(emailInput, 'L\'email est requis');
            return false;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(email)) {
            setFieldError(emailInput, 'Veuillez entrer une adresse email valide');
            return false;
        }
        clearFieldError(emailInput);
        return true;
    }

    function validatePhone() {
        const phone = phoneInput.value.trim();
        if (phone) {
            const phoneRegex = /^[\d\s\+\-\(\)]+$/;
            if (!phoneRegex.test(phone) || phone.length < 10) {
                setFieldError(phoneInput, 'Veuillez entrer un numéro de téléphone valide');
                return false;
            }
        }
        clearFieldError(phoneInput);
        return true;
    }

    function validateSubject() {
        const subject = subjectInput.value.trim();
        if (!subject) {
            setFieldError(subjectInput, 'Le sujet est requis');
            return false;
        }
        if (subject.length < 3) {
            setFieldError(subjectInput, 'Le sujet doit contenir au moins 3 caractères');
            return false;
        }
        clearFieldError(subjectInput);
        return true;
    }

    function validateMessage() {
        const message = messageInput.value.trim();
        if (!message) {
            setFieldError(messageInput, 'Le message est requis');
            return false;
        }
        if (message.length < 10) {
            setFieldError(messageInput, 'Le message doit contenir au moins 10 caractères');
            return false;
        }
        clearFieldError(messageInput);
        return true;
    }

    function setFieldError(field, message) {
        field.classList.add('error');
        let errorDiv = field.parentElement.querySelector('.field-error');
        if (!errorDiv) {
            errorDiv = document.createElement('div');
            errorDiv.className = 'field-error';
            field.parentElement.appendChild(errorDiv);
        }
        errorDiv.textContent = message;
        errorDiv.setAttribute('role', 'alert');
    }

    function clearFieldError(field) {
        field.classList.remove('error');
        const errorDiv = field.parentElement.querySelector('.field-error');
        if (errorDiv) {
            errorDiv.remove();
        }
    }

    contactForm.addEventListener('submit', async function(e) {
        e.preventDefault();

        // Validate all fields
        const isNameValid = validateName();
        const isEmailValid = validateEmail();
        const isPhoneValid = validatePhone();
        const isSubjectValid = validateSubject();
        const isMessageValid = validateMessage();

        if (!isNameValid || !isEmailValid || !isPhoneValid || !isSubjectValid || !isMessageValid) {
            showMessage('Veuillez corriger les erreurs dans le formulaire.', 'error');
            return;
        }

        // Get reCAPTCHA v3 token - Remplacer RECAPTCHA_SITE_KEY par votre clé publique
        let recaptchaToken = '';
        try {
            recaptchaToken = await grecaptcha.execute('RECAPTCHA_SITE_KEY', { action: 'contact' });
        } catch (err) {
            showMessage('Erreur de vérification anti-spam. Veuillez réessayer.', 'error');
            return;
        }

        // Get form data
        const formData = {
            name: nameInput.value.trim(),
            email: emailInput.value.trim(),
            phone: phoneInput.value.trim(),
            subject: subjectInput.value.trim(),
            message: messageInput.value.trim(),
            recaptcha_token: recaptchaToken
        };

        // Disable submit button during processing
        const submitBtn = contactForm.querySelector('button[type="submit"]');
        const originalBtnText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'Envoi en cours...';

        try {
            const response = await fetch('https://www.kalenix.fr/backend/contact.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (result.success) {
                showMessage(result.message || 'Merci pour votre message ! Nous vous contacterons bientôt.', 'success');
                contactForm.reset();
                // Clear all field errors
                [nameInput, emailInput, phoneInput, subjectInput, messageInput].forEach(clearFieldError);
            } else {
                showMessage(result.message || 'Une erreur est survenue. Veuillez réessayer.', 'error');
            }
        } catch (error) {
            console.error('Erreur:', error);
            showMessage('Impossible de contacter le serveur. Veuillez réessayer plus tard.', 'error');
        } finally {
            // Re-enable submit button
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
        }
    });

    function showMessage(message, type) {
        formMessage.textContent = message;
        formMessage.className = `form-message ${type}`;
        formMessage.style.display = 'block';
        formMessage.setAttribute('role', type === 'success' ? 'status' : 'alert');
        formMessage.setAttribute('aria-live', 'polite');

        // Hide message after 5 seconds
        setTimeout(() => {
            formMessage.style.display = 'none';
        }, 5000);
    }

    // Scroll animations
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!prefersReducedMotion && 'IntersectionObserver' in window) {
        const revealElements = document.querySelectorAll(
            '.section-title, .section-subtitle, .service-card, .team-member, .portfolio-carousel, .contact-illustration, .contact-form'
        );

        // Apparition en cascade pour les cartes d'une même grille
        document.querySelectorAll('.services-grid, .team-grid').forEach(grid => {
            Array.from(grid.children).forEach((card, index) => {
                card.style.transitionDelay = `${(index % 6) * 0.1}s`;
            });
        });

        const observer = new IntersectionObserver(function(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: 0.15,
            rootMargin: '0px 0px -60px 0px'
        });

        revealElements.forEach(el => {
            el.classList.add('reveal');
            observer.observe(el);
        });
    }

    // Portfolio Carousel
    const carouselTrack = document.querySelector('.carousel-track');
    const slides = document.querySelectorAll('.carousel-slide');
    const prevBtn = document.querySelector('.carousel-prev');
    const nextBtn = document.querySelector('.carousel-next');
    const indicators = document.querySelectorAll('.indicator');
    let currentSlide = 0;

    function goToSlide(index) {
        slides.forEach(slide => slide.classList.remove('active'));
        indicators.forEach(ind => ind.classList.remove('active'));
        
        slides[index].classList.add('active');
        indicators[index].classList.add('active');
        carouselTrack.style.transform = `translateX(-${index * 100}%)`;
        currentSlide = index;
    }

    function nextSlide() {
        const next = (currentSlide + 1) % slides.length;
        goToSlide(next);
    }

    function prevSlide() {
        const prev = (currentSlide - 1 + slides.length) % slides.length;
        goToSlide(prev);
    }

    if (prevBtn && nextBtn) {
        prevBtn.addEventListener('click', prevSlide);
        nextBtn.addEventListener('click', nextSlide);
        
        indicators.forEach((indicator, index) => {
            indicator.addEventListener('click', () => goToSlide(index));
        });

        // Auto-play carousel
        setInterval(nextSlide, 5000);
    }

    // Active navigation highlight on scroll
    window.addEventListener('scroll', function() {
        let current = '';
        const sections = document.querySelectorAll('section[id]');
        
        sections.forEach(section => {
            const sectionTop = section.offsetTop;
            const sectionHeight = section.clientHeight;
            if (scrollY >= (sectionTop - 200)) {
                current = section.getAttribute('id');
            }
        });

        navLinks.forEach(link => {
            link.classList.remove('active');
            if (link.getAttribute('href') === `#${current}`) {
                link.classList.add('active');
            }
        });
    });
});
